import { AbstractModel } from '@uzurv/core';
import { CollectionSiteAttribute } from './collection-site-attribute';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { CollectionSiteHours } from './collection-site-hours';

@inheritSerialization(AbstractModel)
export class CollectionSite extends AbstractModel {
  @autoserialize
  address1: string;

  @autoserialize
  address2: string;

  @autoserializeAs(CollectionSiteAttribute)
  attributes: Array<CollectionSiteAttribute>;

  @autoserializeAs(CollectionSiteHours)
  siteHours: CollectionSiteHours;

  @autoserialize
  city: string;

  @autoserialize
  distance: number;

  @autoserialize
  distanceMeasureType: string;

  @autoserialize
  electronicPhysicalEnabled: boolean;

  @autoserialize
  escreenSiteId: number;

  @autoserialize
  faxNumber: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  occHealthNetwork: string;

  @autoserialize
  partnerSiteId: string;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  siteName: string;

  @autoserialize
  state: string;

  @autoserialize
  zipCode: string;
}
